export default __webpack_public_path__ + "static/media/FirstImageModel.337f91ff.png";